module.exports = __webpack_public_path__ + "static/fonts/NanumSquareB.ada293a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareB.woff
// module id = i6Mb
// module chunks = 1